"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceConnector = void 0;
class DeviceConnector {
    constructor() {
        this.isAnyoneListening = () => {
            return typeof window.nativeResponse === 'function';
        };
        this.listen = (callback) => {
            if (typeof window !== 'undefined') {
                window.nativeResponse = callback;
            }
        };
    }
}
exports.DeviceConnector = DeviceConnector;
//# sourceMappingURL=deviceConnector.js.map